import React, {useState} from 'react';
import {debounce} from 'lodash';
import Select, {SingleValue} from 'react-select';
import mapboxFetchers from 'src/api/fetchers/mapbox';
import {MapboxFeature} from 'src/types/mapbox';
import clsx from 'clsx';
import styles from './MapboxSearchInput.module.scss';

type Option = MapboxFeature | null;

type MapboxSearchInputProps = {
  placeholder?: string;
  onSelect: (value: SingleValue<Option>) => void;
};

function MapboxSearchInput(props: MapboxSearchInputProps) {
  const {placeholder, onSelect} = props;
  const [suggestions, setSuggestions] = useState<MapboxFeature[]>([]);

  const search = debounce(async (searchValue) => {
    if (!searchValue) {
      setSuggestions([]);
      return;
    }

    try {
      const response = await mapboxFetchers.places(searchValue);
      setSuggestions(response.data?.features ?? []);
    } catch {
      setSuggestions([]);
    }
  }, 500);

  return (
    <Select<Option, false>
      placeholder={placeholder}
      options={suggestions}
      onInputChange={search}
      onChange={onSelect}
      getOptionLabel={(option: Option) => option?.place_name ?? ''}
      getOptionValue={(option: Option) => option?.id ?? ''}
      isClearable
      backspaceRemovesValue
      components={{
        DropdownIndicator: null,
        ClearIndicator: undefined,
      }}
      noOptionsMessage={() => null}
      loadingMessage={() => null}
      escapeClearsValue={false}
      filterOption={null}
      classNames={{
        control: () => styles.control,
        menu: () => styles.menu,
        menuList: () => styles.menuList,
        option: (state) =>
          clsx(styles.option, state.isFocused && styles.option__focused),
      }}
    />
  );
}

export default MapboxSearchInput;
